import { ApiUrl } from '@common/enums';
import { CornerRadiusModel } from '@common/models';
import { easyEstimatorApi } from '@ee-api/easyEstimatorService';
import { CommonProductQueryParams } from '@ee-api/queryParams';

const cornerRadiiService = easyEstimatorApi.injectEndpoints({
    endpoints: (builder) => ({
        fetchCornerRadii: builder.query<CornerRadiusModel[], CommonProductQueryParams>({
            query: ({ params }) => ({
                url: `${ApiUrl.CORNER_RADII}`,
                method: 'GET',
                params,
            }),
            transformResponse: (data: CornerRadiusModel[] | '' | null) => (data ? data : []),
        }),
    }),
});

export const { useFetchCornerRadiiQuery, useLazyFetchCornerRadiiQuery } = cornerRadiiService;
